import { Component, EventEmitter, Output, inject } from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { CustomModalComponent } from '@/components/custom-modal/custom-modal.component';
import { DocumentDeviceMonitorService } from '@/offline/document-device-monitor.service';
import { DocumentDeviceService } from '@/offline/document-device.service';
import { Utils } from '@/utils/utils';

@Component({
    selector: 'app-document-device-form',
    imports: [ReactiveFormsModule, CustomModalComponent],
    templateUrl: './document-device-form.component.html',
})
export class DocumentDeviceFormComponent {
    @Output() closeFunction = new EventEmitter<any>();
    @Output() acceptFunction = new EventEmitter<any>();

    private documentDeviceService = inject(DocumentDeviceService);
    private documentDeviceMonitor = inject(DocumentDeviceMonitorService);

    nameControl = new FormControl(this.documentDeviceService.readIdentity()?.name ?? '', [Validators.required]);

    isThisDevice = !!this.documentDeviceService.readIdentity();

    /** Purely informational (from whatever this browser has itself heard over the websocket) - there's no server record to check against, so this can't be a hard confirm. */
    get otherActiveDeviceName(): string | null {
        const status = this.documentDeviceMonitor.status();
        if (!status || this.documentDeviceMonitor.isStale(status)) return null;
        if (this.isThisDevice && status.name === this.nameControl.value) return null;
        return status.name;
    }

    acceptFormFunction(): void {
        if (!this.nameControl.valid) {
            Utils.notification.alert('Ponle un nombre a este ordenador (por ejemplo, "Caja principal")');
            return;
        }

        this.documentDeviceService.designate(this.nameControl.value || '');
        Utils.notification.success('Este ordenador ha sido designado como dispositivo de respaldo offline');
        this.acceptFunction.emit();
    }

    stopBeingDevice(): void {
        this.documentDeviceService.forget();
        this.acceptFunction.emit();
    }

    closeFormFunction(): void {
        this.closeFunction.emit();
    }
}
